import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../../views/LoadingPage/Loadingpage";
import { API_BASE_URL, directToken, Roles_list } from "../services/end_points";
import { _get } from "../services/service_api";
// export function ProtectedRoutes({ Component, name }) {
//   console.log("NAMES", name);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [hasAccess, setHasAccess] = useState(false);
//   useEffect(() => {
//     const user = localStorage.getItem("userid");
//     if (user) {
//       getRoles(user);
//     } else {
//       navigate("/");
//     }
//   }, [name, navigate]);
//   const getRoles = async (user) => {
//     try {
//       const response = await _get(
//         `${API_BASE_URL}${Roles_list}${user}`,
//         directToken
//       );
//       const roles = response?.data?.list || [];

//       console.log("data to access", roles);
//       const access = checkAccess(roles, name);
//       console.log("data to access", access);
//       setHasAccess(access);
//       if (!access) {
//         navigate("/");
//       }
//     } catch (error) {
//       console.error("Error fetching roles:", error);
//       navigate("/");
//     } finally {
//       setLoading(false);
//     }
//   };
//   const checkAccess = (roles, route) => {
//     console.log("Check access", roles);
//     if (!Array.isArray(roles)) {
//       throw new TypeError("Expected an array of roles");
//     }

//     const routeMapping = {
//       dashboard: "dashbord",
//       appointment: "appointment",
//       userManagement: "userManagement",
//       dataManagement: "dataManagement",
//       hospital: "hospital",
//       speciality: "speciality",
//       assignSpeciality: "assignSpeciality",
//       city: "city",
//       Report: "Report",
//     };
//     const normalizedRoute = routeMapping[route] || route;
//     const componentAccess = roles.map((role) => {
//       if (typeof role !== "object" || role === null) {
//         throw new TypeError("Each role should be an object");
//       }
//       return role[normalizedRoute];
//     });
//     console.log("Component Access Array:", componentAccess);
//     console.log(
//       "Access Condition (some):",
//       componentAccess.some((access) => access === 1)
//     );
//     console.log(
//       "Access Condition (every):",
//       componentAccess.every((access) => access === 1)
//     );

//     return componentAccess.some((access) => access === 1);
//   };
//   if (loading) {
//     return <LoadingPage />;
//   }
//   if (!hasAccess) {
//     return <div>No access</div>;
//   }
//   return <Component />;
// }
export function ProtectedRoutes({ Component, name }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("userid");
    if (user) {
      getRoles(user);
    } else {
      navigate("/"); // Redirect to login if no user ID
    }
  }, [name, navigate]);

  const getRoles = async (user) => {
    try {
      const response = await _get(
        `${API_BASE_URL}${Roles_list}${user}`,
        directToken
      );
      const roles = response?.data?.list || [];

      const access = checkAccess(roles, name);

      setHasAccess(access);

      if (!access) {
        navigate("/"); // Redirect if no access
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      navigate("/"); // Redirect on error
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

  const checkAccess = (roles, route) => {
    if (!Array.isArray(roles)) {
      console.error("Roles must be an array");
      return false;
    }

    // Mapping of route to corresponding key in the role object
    const routeMapping = {
      dashboard: "dashbord",
      appointment: "appointment",
      userManagement: "userManagement",
      dataManagement: "dataManagement",
      hospital: "hospital",
      speciality: "speciality",
      assignSpeciality: "assignSpeciality",
      city: "city",
      Report: "Report",
    };

    const normalizedRoute = routeMapping[route] || route;

    // Check access for each role based on the normalized route
    const hasAccess = roles.some((role) => {
      const access = role[normalizedRoute] || 0;

      return access === 1; // Return true if any role has access (1)
    });

    return hasAccess;
  };

  if (loading) {
    return <LoadingPage />; // Show loading page while fetching roles
  }

  if (!hasAccess) {
    return <div>No access</div>; // Display no access message
  }

  return <Component />; // Render the protected component if access is granted
}
